export default {"src":"/_next/static/media/chevron-down.db64cc56.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};